interface FooterProps {
  sidebarCollapsed: boolean;
}

export function Footer({ sidebarCollapsed }: FooterProps) {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={`app-footer ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
      <span>&copy; {currentYear} BookuID. Sistem Akuntansi Terpadu.</span>
    </footer>
  );
}
